import script from "./commission-transfer.vue?vue&type=script&setup=true&lang=js"
export * from "./commission-transfer.vue?vue&type=script&setup=true&lang=js"

import "./commission-transfer.vue?vue&type=style&index=0&id=935c23f8&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-935c23f8"]])

export default __exports__